import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import GlassCard from "../components/GlassCard";
import PrimaryButton, { GlassButton } from "../components/PrimaryButton";
import PageShell from "../components/PageShell";

const WriteNotes = () => {
  const nav = useNavigate();
  const clientName = sessionStorage.getItem("well_client_name") || "";
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!clientName) nav("/new-session", { replace: true });
  }, [clientName, nav]);

  const reviewAndSend = async () => {
    if (!notes.trim()) {
      setError("Please write your notes before continuing.");
      return;
    }
    setSaving(true);
    try {
      const r = await api.post("/sessions/manual", {
        client_name: clientName,
        notes_content: notes.trim(),
      });
      nav(`/review/${r.data.session_id}`, { replace: true });
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not save notes.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageShell showSettings>
      <div className="pt-16 pb-32 max-w-3xl mx-auto flex flex-col gap-6 well-page-enter">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-[#2A3B32]">Write Notes</h1>
          <p className="mt-1 text-sm text-[#8A9C91]">Session with {clientName || "your client"}</p>
        </div>
        <GlassCard className="!p-2 sm:!p-4">
          <textarea
            value={notes}
            onChange={(e) => { setNotes(e.target.value); setError(""); }}
            placeholder="Type your session notes — observations, themes, breakthroughs, next steps…"
            rows={18}
            data-testid="write-notes-textarea"
            className="w-full bg-transparent text-[#2A3B32] rounded-[16px] p-4 sm:p-6 focus:outline-none resize-none text-base leading-relaxed placeholder:text-[#8A9C91]"
            autoFocus
          />
        </GlassCard>
        {error && <p className="text-center text-sm text-[#B85C5C]" data-testid="write-notes-error">{error}</p>}
        <div className="max-w-md mx-auto w-full flex flex-col gap-3">
          <PrimaryButton onClick={reviewAndSend} disabled={saving} data-testid="review-and-send-btn">
            {saving ? "Saving…" : "Review and Send"}
          </PrimaryButton>
          <GlassButton onClick={() => nav(-1)} data-testid="write-notes-back-btn">Back</GlassButton>
        </div>
      </div>
    </PageShell>
  );
};

export default WriteNotes;
